export default {
  MuiMenu: {
    styleOverrides: {
      list: {
        minWidth: '140px'
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '16px',
        paddingRight: '16px',
        '&:hover': {
          backgroundColor: '#F4F9FF'
        }
      }
    }
  }
};
